<template>
  <div class="user-company-dropdown d-flex align-items-center">
    <b-dropdown
      right
      no-caret
      size="lg"
      variant="sm"
      class="d-none d-lg-flex align-items-center"
      menu-class="resize-dropdown"
      toggle-class="text-decoration-none"
    >
      <template #button-content>
        <snow-button icon="ph ph-users-three" variant="borderless" />
      </template>
      <company-dropdown-content
        :companies="companies"
        @close="visible = false"
      />
    </b-dropdown>

    <snow-button
      icon="ph ph-users-three text-orange"
      variant="borderless"
      class="d-lg-none"
      @click="visible = true"
    />
    <b-modal
      v-model="visible"
      content-class="fixed-on-top"
      hide-header
      hide-footer
    >
      <company-dropdown-content
        :companies="companies"
        @close="visible = false"
      />
      <div
        class="draggable-line d-flex justify-content-center mt-3"
        @click="visible = false"
        role="button"
      />
    </b-modal>
  </div>
</template>

<script>
import CompanyDropdownContent from "./CompanyDropdownContent.vue";

export default {
  components: { CompanyDropdownContent },
  props: {
    companies: Array
  },
  data() {
    return {
      visible: false
    };
  }
};
</script>

<style lang="scss" scoped>
.user-company-dropdown {
  display: flex;
  justify-content: flex-end;
  background: transparent;
  padding-left: 8px;
  ::v-deep.dropdown-menu.show {
    border-radius: 16px;
    padding: 10px;
    min-width: 265px !important;
    max-width: 365px !important;
    box-shadow: 0px 4.99685px 14.99054px 0px rgba(0, 0, 0, 0.15),
      0px 16px 32px 12px rgba(0, 0, 0, 0.08);
  }
}
</style>
